import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defer, finalize, Observable } from 'rxjs';
import { PendingRequestService } from '../services/pending-request.service';

const DATA_CHANGING_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];

@Injectable({
  providedIn: 'root',
})
export class PendingRequestInterceptor implements HttpInterceptor {
  constructor(private pendingRequestService: PendingRequestService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!DATA_CHANGING_METHODS.includes(request.method)) {
      return next.handle(request);
    }
    return defer(() => {
      const settle = this.pendingRequestService.track();
      return next.handle(request).pipe(finalize(settle));
    });
  }
}
